
import { defineComponent } from 'vue';

/**
 * pIconInfo 정보
  {
    iconText: string,
    pointYn?: boolean,
    noBorder?: boolean,
    imgPath?: string,
    isCircle?: boolean,
  }
 */

export default defineComponent({
  props: {
    pIconInfo: Object as any,
    pPointYn: Boolean,
  },
  data() {
    return {};
  },
});
